/* global axios */

// Store de limites operacionais do plano.
// Consulta /api/v1/accounts/:id/subscription_limits e expõe:
//   isAtLimit(key)  → true se o uso atual atingiu o limite do plano
//   limitFor(key)   → valor do limite (null = ilimitado)
//   usageFor(key)   → uso atual

const state = {
  limits: {},
  usage: {},
  isFetching: false,
};

const getters = {
  isFetching: $state => $state.isFetching,
  limits: $state => $state.limits,
  usage: $state => $state.usage,

  // Verifica se o limite foi atingido. null = ilimitado → sempre false.
  isAtLimit: $state => key => {
    const max = $state.limits[key];
    if (max === null || max === undefined) return false;
    const current = $state.usage[key] ?? 0;
    return current >= Number(max);
  },

  limitFor: $state => key => $state.limits[key] ?? null,
  usageFor: $state => key => $state.usage[key] ?? 0,
};

const mutations = {
  SET_DATA($state, { limits, usage }) {
    $state.limits = limits || {};
    $state.usage = usage || {};
  },
  SET_FETCHING($state, value) {
    $state.isFetching = value;
  },
};

const actions = {
  async fetch({ commit, rootGetters }) {
    const accountId = rootGetters.getCurrentAccountId;
    if (!accountId) return;
    commit('SET_FETCHING', true);
    try {
      const { data } = await axios.get(
        `/api/v1/accounts/${accountId}/subscription_limits`
      );
      commit('SET_DATA', {
        limits: data.limits || {},
        usage: data.usage || {},
      });
    } catch {
      // silencioso
    } finally {
      commit('SET_FETCHING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
